"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ajax_1 = require("rxjs/ajax");
class Api {
    request(request) {
        return ajax_1.ajax(request);
    }
    get(url, headers, urlParams) {
        return ajax_1.ajax.get(url + this._serialize(urlParams), headers || {});
    }
    post(url, body, headers, urlParams) {
        return ajax_1.ajax.post(url + this._serialize(urlParams), body, headers || {});
    }
    put(url, body, headers, urlParams) {
        return ajax_1.ajax.put(url + this._serialize(urlParams), body, headers || {});
    }
    graphql(url, variables, query, headers, response, error) {
        return ajax_1.ajax.post(url, { query, variables }, headers).subscribe(res => response(res.response), error);
    }
    delete(url, headers, urlParams) {
        return ajax_1.ajax.delete(url + this._serialize(urlParams), headers || {});
    }
    _serialize(obj) {
        if (!obj || typeof obj !== 'object')
            return '';
        let query = '?';
        Object.keys(obj).forEach(value => {
            query += `${value}=${obj[value]}&`;
        });
        return query;
    }
}
Api.instance = () => {
    if (!(Api._instance instanceof Api)) {
        Api._instance = new Api();
    }
    return Api._instance;
};
exports.Api = Api;
exports.default = Api.instance();
//# sourceMappingURL=index.js.map